"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Exported promotion forecast converter.
 *
 * @author VRu
 */


var PreExportedPromotionForecastConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PreExportedPromotionForecastConverter, _DataObjectConverter_);

  function PreExportedPromotionForecastConverter() {
    _classCallCheck(this, PreExportedPromotionForecastConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PreExportedPromotionForecastConverter).apply(this, arguments));
  }

  return PreExportedPromotionForecastConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PreExportedPromotionForecastConverter = PreExportedPromotionForecastConverter;